var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: { size: "modal-small", "close-strict": true },
          on: {
            close: function($event) {
              _vm.$emit("close")
            }
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal-body-scroll",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "loader-circle"
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row are-you-sure-wrapper",
                  class: [_vm.loading ? "opacity-2" : ""]
                },
                [
                  _c("div", { staticClass: "col-md-12 mb-3" }, [
                    _c("h5", { staticClass: "font-weight-bold" }, [
                      _vm._v("Remove file")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 text-center mb-2" }, [
                    _c("p", [
                      _vm._v("\n            You are about to delete the file "),
                      _c("b", [_vm._v(_vm._s(_vm.file.name))]),
                      _vm._v(". Are you sure?\n          ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-12 text-center are-you-sure-actions mt-4"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mt-3" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              on: {
                                click: function($event) {
                                  _vm.$emit("close")
                                }
                              }
                            },
                            [_vm._v("\n              No, cancel\n            ")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mt-3" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: {
                                click: function($event) {
                                  _vm.deleteFile()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              Yes, delete file\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75573b47", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75573b47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/modals/AreYouSureDeleteFile.vue
// module id = null
// module chunks = 